/** Board coordinates stay in cells; the camera alone controls screen pixels. */
export class BoardCamera {
  width = 1;
  height = 1;
  columns = 1;
  rows = 1;
  fitScale = 1;
  zoom = 1;
  x = 0;
  y = 0;
  readonly maxZoom = 6;
  get scale(): number { return this.fitScale * this.zoom; }

  resize(width: number, height: number, columns: number, rows: number, reset = false): void {
    const center = this.toWorld(this.width / 2, this.height / 2);
    this.width = width; this.height = height;
    this.columns = columns; this.rows = rows;
    this.fitScale = Math.max(.1, Math.min((width - 22) / columns, (height - 22) / rows));
    if (reset) this.fit();
    else {
      this.x = width / 2 - center.x * this.scale;
      this.y = height / 2 - center.y * this.scale;
      this.clamp();
    }
  }
  toWorld(x: number, y: number): { x: number; y: number } {
    return { x: (x - this.x) / this.scale, y: (y - this.y) / this.scale };
  }
  fit(): void {
    this.zoom = 1;
    this.x = (this.width - this.columns * this.scale) / 2;
    this.y = (this.height - this.rows * this.scale) / 2;
  }
  zoomAt(zoom: number, x = this.width / 2, y = this.height / 2): void {
    const anchor = this.toWorld(x, y);
    this.zoom = Math.max(1, Math.min(this.maxZoom, zoom));
    this.x = x - anchor.x * this.scale;
    this.y = y - anchor.y * this.scale;
    this.clamp();
  }
  pan(dx: number, dy: number): void { this.x += dx; this.y += dy; this.clamp(); }
  reveal(x: number, y: number): void {
    const px = this.x + x * this.scale, py = this.y + y * this.scale;
    if (px >= 24 && px <= this.width - 24 && py >= 24 && py <= this.height - 24) return;
    this.x = this.width / 2 - x * this.scale;
    this.y = this.height / 2 - y * this.scale;
    this.clamp();
  }
  private clamp(): void {
    const axis = (offset: number, view: number, size: number) => size <= view - 22
      ? (view - size) / 2 : Math.max(view - 11 - size, Math.min(11, offset));
    this.x = axis(this.x, this.width, this.columns * this.scale);
    this.y = axis(this.y, this.height, this.rows * this.scale);
  }
}
